<template>
	<view class="content">
		<image class="logo" src="/static/logo.png"></image>
    <van-one-pic></van-one-pic>
		<lPainter
			ref="painter"
			:board="posterObj"
			@success="success"
			@done="done"
			:isCanvasToTempFilePath="true"
			path-type="url"
		>
		</lPainter>
		12
		<!-- <image :src="$getImg()"></image> -->
		<view>
			<text class="title">{{title}}</text>
		</view>
	</view>
</template>


<script>
	export default {
		components:{
			// uniVanTwoSlide
		},
		data() {
			return {
				title: 'Hello',
				path:'',
				posterObj:null
			}
		},
		onLoad() {
		},
		onReady(){
			console.log('123')
			this.posterObj={
  "width": "670rpx",
  "height": "720rpx",
  "background": "#fff",
  "borderRadius": "16rpx",
  "views": [
    {
      "type": "image",
      "src": "https://cdn-ygj-base-dev.lishicloud.com/sopOss/202304/12/19fbc8cb85f24313b10b7364cbea3369.JPG",
      "mode": "aspectFill",
      "css": {
        "width": "670rpx",
        "height": "390rpx",
        "objectFit": "cover",
        "objectPosition": "50% 50%",
        "borderRadius": "10rpx 10rpx 0 0",
        "overflow": "hidden",
        "backgroundColor": "#fff",
        "position": "absolute",
        "left": "0rpx",
        "top": "0rpx",
        "fontSize": "0"
      }
    },
    {
      "type": "text",
      "text": "测试报名活动-需审核测试两行数据测试两行数据测试两行数据测试两行数据",
      "css": {
        "fontSize": "30rpx",
        "fontFamily": "PingFangSC-Medium, PingFang SC",
        "fontWeight": "500",
        "color": "#262626",
        "lineHeight": "48rpx",
        "position": "absolute",
        "left": "28rpx",
        "top": "414rpx",
        "width": "614rpx",
        "height": "100rpx"
      }
    },
    {
      "type": "image",
      "src": "https://cdn-ygj-base-dev.lishicloud.com/sopOss/202304/27/cf172598847c439597c29ac123157216.png",
      "css": {
        "position": "absolute",
        "left": "250rpx",
        "top": "530rpx",
        "width": "170rpx",
        "height": "170rpx",
        "objectFit": "contain",
        "objectPosition": "50% 50%",
        "fontSize": "0"
      }
    }
  ]
}
		},
		methods: {
			success(e) {
			this.path = e
			this.showSave = true
			console.log('------path-success', this.path)
			},
			done() {
      console.log('------done', this.path)
      uni.hideLoading()
    },
		}
	}
</script>

<style lang="less" scoped>
	.content {
		text-align: center;
		height: 400upx;
	}

	.logo {
		height: 200upx;
		width: 200upx;
		margin-top: 200upx;
	}

	.title {
		font-size: 36upx;
		color: #8f8f94;
	}
</style>
